import { useDraggable } from '@dnd-kit/core';
import { StyledDraggableGapOption } from './DraggableGapOption.styled';

export default function DraggableGapOption({
  id,
  className,
  text,
  children,
  disabled,
}) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
    data: { text },
    disabled,
  });

  return (
    <StyledDraggableGapOption
      ref={setNodeRef}
      className={className}
      style={
        transform
          ? {
              transform: `translate(${transform.x}px, ${transform.y}px scale(1.1,1.1))`,
              touchAction: 'none',
            }
          : { touchAction: 'none' }
      }
      {...listeners}
      {...attributes}
    >
      {children}
    </StyledDraggableGapOption>
  );
}
